export default __webpack_public_path__ + "static/media/ch.bb13e8d7.svg";